import {
  aCreateInsightResolution,
  anInsightResolution,
  mockCreateInsightResolutionMutationOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockCreateInsightResolutionMutationOperationMutation(
    async ({ query: _query, variables }) => {
      await delay(150);
      const {
        fields: { name, description },
      } = variables;

      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          createInsightResolution: aCreateInsightResolution({
            data: {
              ...anInsightResolution(),
              name: name ?? anInsightResolution().name,
              description: description ?? anInsightResolution().description,
              subResolutions: [],
            },
          }),
        },
      });
    }
  ),
];
